<template>
  <StoreCollectionBinding />
</template>

<script>
import StoreCollectionBinding from "@/views/apps/weishop/merchants/setting/store_collection_binding.vue";

export default {
  name: "RegionStoreWechatBindingAdapter",
  components: {
    StoreCollectionBinding,
  },
};
</script>
